import { gql, useQuery } from '@apollo/client';
import { callSideEffects } from '../../util';
import { CurrencyFormats } from '../../contracts/types';
const HOTEL_TEASER_PRICE_QUERY = gql `
    query HotelTeaserPrices($request: HotelTeaserPricesRequest!, $format: CurrencyFormats) {
        hotelTeaserPrices(request: $request) {
            prices {
                date
                price
                priceFormatted(format: $format)
                pricePerPerson
                pricePerPersonFormatted(format: $format)
            }
        }
    }
`;
export function useHotelTeaserPrices(hotelTeaserPricesRequest, sideEffects, errorSideEffects, skipQuery = false) {
    const { estabID, tripStateId, calendarMonthYear, departureAirports, duration, isHoliday, people } = hotelTeaserPricesRequest;
    const skip = Boolean(tripStateId ? !estabID || !calendarMonthYear : !people || !duration || (isHoliday && !departureAirports)) || skipQuery;
    return useQuery(HOTEL_TEASER_PRICE_QUERY, {
        notifyOnNetworkStatusChange: true,
        ssr: false,
        variables: {
            request: hotelTeaserPricesRequest,
            format: CurrencyFormats.Rounded,
        },
        skip,
        onCompleted: (completedData) => {
            if (sideEffects) {
                callSideEffects(sideEffects, completedData);
            }
        },
        onError: (err) => {
            callSideEffects(errorSideEffects, err);
        },
    });
}
